import React from 'react';
import { makeStyles } from '@material-ui/styles';

import useArticle from './useArticle';

import Header from './header';
import Footer from './footer';
import Sidebar from './sidebar';
import Main from './main';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    display: 'flex',
    flex: 1,
    overflowY: 'auto',
  },
  sidebar: {
    width: 272,
    height: '100%',
  },
  mainContent: {
    flex: 1,
    maxWidth: 1088,
    overflowY: 'auto',
    margin: '32px auto',
    padding: '48px 72px',
    boxShadow:
      '0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05)',
  },
}));

const DesignPage = () => {
  const classes = useStyles();

  const {
    type,
    articleTypeIndex,
    index,
    activeIndex,
    title,
    status,
    data,
    btnLoading,
    addContent,
    removeContent,
    handleSetActiveIdx,
    handleValueChange,
    handleSortClick,
    handleSaveArticle,
  } = useArticle();

  return (
    <div className={classes.container}>
      <Header
        type={type}
        articleTypeIndex={articleTypeIndex}
        index={index}
        title={title}
        status={status}
      />

      <div className={classes.main}>
        <div className={classes.sidebar}>
          <Sidebar
            data={data}
            activeIndex={activeIndex}
            handleFocus={handleSetActiveIdx}
            handleSortClick={handleSortClick}
            handleAddContent={addContent}
          />
        </div>

        <div className={classes.mainContent}>
          <Main
            data={data}
            activeIndex={activeIndex}
            handleFocus={handleSetActiveIdx}
            handleValueChange={handleValueChange}
            handleRemoveClick={removeContent}
          />
        </div>
      </div>

      <Footer
        status={status}
        loading={btnLoading}
        disabled={!title}
        handleSaveArticle={handleSaveArticle}
      />
    </div>
  );
};

export default DesignPage;
